import { SealingService } from '../connections';

export async function download(id: number) {
  const result = await SealingService.fetchFile(`Pdfs/${id}/downloadWithAnnotations`);

  result.download();
}

export function remove(id: number) {
  return SealingService.delete(`pdfs/${id}`);
}

export function reset(id: number) {
  return SealingService.post(`pdfs/${id}/reset`);
}

export function saveNotes(id: number, notes: string) {
  return SealingService.patch(`pdfs/${id}/saveNotes`, { data: notes });
}
